import React from 'react';

export default class QuestionAccordionHeader extends React.Component {

  handleDelete = e => {
    e.stopPropagation();
    this.props.handleDelete();
  };

  render(){
    return(
      <div className="question-accordion-item">
        <div className="question-accordion-head">
          <div className="question-accordion-head-inner">
            <div className="question-accordion-caption">
              <p className="question-accordion-label">{this.props.label}</p>
              <p className="question-accordion-title">{this.props.caption}</p>
            </div>
          </div>
          {this.props.candelete &&
            <div className="span delete" onClick={this.handleDelete}><i className="ic-close-ico"/></div>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/creat_public_webinar/create_module/create_question/QuestionAccordionHeader.jsx